export default {
    toggleLanguageText: 'English',
    changePassword: 'Cambiar Contraseña',
    closeSession: 'Cerrar Sesión',
    exportDialog: {
        title: 'Generando reporte...',
        message: 'Estamos generando el CSV. Este proceso puede tardar unos segundos.',
        dontClose: 'No cierres la ventana'
    },
    exportButton: 'Exportar',
    exportButtonFull: 'a CSV',
    documents: {
        title: 'Documentos',
        filters: {
            initialRegistrationDate: 'Fecha Inicial de Registro',
            finalRegistrationDate: 'Fecha Final de Registro',
            initialDocumentDate: 'Fecha Inicial de Documento',
            finalDocumentDate: 'Fecha Final de Documento',
            supplier: 'Proveedor',
            documentType: 'Tipo de Documento',
            supplierType: 'Tipo de Proveedor',
            status: 'Estatus',
            purchaseOrder: 'Orden de Compra',
            organizationCode: 'Código de la Organización',
            invoiceNo: 'No. de Factura',
            uuid: 'UUID',
            active: 'Activo'
        },
        buttons: {
            cancel: 'Cancelar',
            accept: 'Aceptar',
            clear: 'Limpiar',
            go: 'Ir',
            goToPage: 'Ir página'
        },
        headers: {
            invoiceNo: 'No. de Factura',
            uuid: 'UUID',
            registrationDate: 'Fecha Registro',
            documentDate: 'Fecha Documento',
            organizationCode: 'Código de la Organización',
            supplierNo: 'No. Proveedor',
            supplier: 'Proveedor',
            status: 'Estatus',
            details: 'Detalles',
            sapResponse: 'Respuesta SAP',
            sapResponseDetails: 'Detalles respuesta SAP',
            documentNo: 'Número de Documento',
            accountingDocumentNo: 'No. Documento Contable',
            phase: 'Fase',
            documentType: 'Tipo Documento',
            supplierType: 'Tipo Proveedor',
            relatedDoc: 'Docto. Relacionado ',
            comments: 'Comentarios',
            active: 'Activo',
            uploadMethod: 'Tipo Carga',
            company: 'Compañía'
        },
        pagination: {
            itemsPerPage: 'Elementos por página:',
            page: 'Página:',
            pageShort: 'Pág:',
            of: 'de'
        },
        messages: {
            noDocument: 'Sin documento',
            noComments: 'Sin comentarios',
            yes: 'Si',
            no: 'No',
            noRecords: 'No hay registros para sus parámetros de búsqueda. Favor de intentar otra búsqueda o crear uno nuevo.',
            formUpdateSuccess: 'Registro actualizado con éxito.',
            formUpdateError: 'Error al actualizar registro.',
            formCancelSuccess: 'Registro cancelado con éxito.',
            formCancelError: 'Error al cancelar registro.',
            formDownloadError: 'Error al descargar los archivos.',
            formLoadError: 'Error al obtener registro.'
        },
        documentTypes: {
            invoice: 'Factura',
            paymentComplement: 'Complemento de pago'
        }
    },
    errors: {
        errorGetList: 'Hubo un problema al obtener la lista',
        errorGetSuppliers: 'Hubo un problema al obtener la lista de proveedores',
        errorGetStatuses: 'Hubo un problema al obtener la lista de estatus',
        errorGetSupplierTypes: 'Hubo un problema al obtener la lista de tipos de proveedores',
        errorGetUuids: 'Hubo un problema al obtener la lista de UUIDs',
        invalidPageNumber: 'No existe el número de página ingresado',
        exportError: 'Error al exportar CSV',
        exportCsvProcessing: 'Hubo un problema al procesar el CSV. Por favor, intente nuevamente.'
    }
}

